export const vercel = {
  LIVE_URL: 'https://vercel.live/',
  VERCEL_URL: 'https://vercel.com',
  SOCKETJS_URL: 'https://sockjs-mt1.pusher.com/',
  WSS_URL: 'wss://ws-mt1.pusher.com/',
  WEB_VITALS_URL: 'vitals.vercel-insights.com',
};
